module.exports = __webpack_public_path__ + "static/media/Programing-sm_1x.77d4d662.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Programing/Programing-sm_1x.webp
// module id = 763
// module chunks = 0